import { render } from "./ApprovedClearanceCertificates.vue?vue&type=template&id=85e51050&scoped=true"
import script from "./ApprovedClearanceCertificates.vue?vue&type=script&lang=js"
export * from "./ApprovedClearanceCertificates.vue?vue&type=script&lang=js"

import "./ApprovedClearanceCertificates.vue?vue&type=style&index=0&id=85e51050&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85e51050"]])

export default __exports__